<template>
    <div class="Sac-Principal">
        <PageTitle icon="fa fa-phone" main="Importação de recibos de pagamento"
            sub="GLOBUS / JB" />
        <div class="Folha-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Importação" active><FolReciboImportacao /></b-tab>                                                                                                                                            
                    <b-tab title="Indicadores"><FolReciboPainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import FolReciboImportacao from '../folhapagamento/FolImportacaoRecibo'
import FolReciboPainel from '../folhapagamento/FolImportacaoRecibo'
export default {
    name: 'SacPrincipal',    
    components: { PageTitle, FolReciboImportacao,FolReciboPainel}
    
}
</script>

<style>

</style>






